import { AnalyticsIcon, AssetsFilledIcon, AssetsIcon, BroadcastsIcon, CalendarAllIcon, CouponFilledIcon, CouponIcon, CustomerGroupsFilledIcon, CustomerGroupsIcon, CustomersFilledIcon, CustomersIcon, DashboardFilledIcon, DashboardIcon, FileManagerFilledIcon, FileManagerIcon, HandymanIcon, ImportIcon, InboxFilledIcon, InboxIcon, InsertChartDataFilledIcon, InsertChartDataIcon, JourneyFilledIcon, JourneyIcon, LandingPagesIcon, ListAltFilledIcon, ListAltIcon, MarketingFilledIcon, MarketingIcon, RepeatTransactionCalculatorIcon, ReviewFilledIcon, ReviewIcon, FactCheckIcon, FactCheckFilledIcon, SMSIcon, SegmentIcon, SmsFilledIcon, SurveyResponsesIcon, TemplatesFilledIcon, TemplatesIcon, TransactionFilledIcon, TransactionIcon, WebFormIcon, AppsIcon, AppsFilledIcon, HomeIcon, HomeFilledIcon, GridFilledIcon, QrCodeIcon, CallIcon, CallFilledIcon, SupportAgentFilledIcon, Calendar30DaysIcon, Calendar30DaysFilledIcon, IntegrationsIcon, SmartToyIcon, ScienceIcon, ScienceFilledIcon } from 'components/mui';
import { legacyAiLinkShown } from 'components/cinch-ai/cinch-ai-gate';
const makeNavigationLink = link => {
  //turning off for now
  return `/${link}`;
  let params = 'date_after=' + moment().subtract(7, 'days').startOf('day').toISOString();
  if (link == 'messaging') {
    params += '&direction=incoming';
  }
  if (link == 'survey-responses') {
    params += '&has_response=true';
  }
  return `/${link}?${params}`;
};
export const MENU_ITEMS = [{
  key: '/dashboard',
  name: 'Dashboard',
  icon: DashboardIcon,
  iconFilled: DashboardFilledIcon,
  // CIN-6639: Catalyst users get the dashboard too, limited server-side to the
  // location-scoped widgets (backendsafe app/widgets/catalyst.py).
  enabled: ({
    isPLG
  }) => !isPLG
}, {
  key: '/companies',
  name: 'Companies',
  icon: DashboardIcon,
  iconFilled: DashboardFilledIcon,
  enabled: ({
    isCatalystUser,
    isPLG
  }) => !!isCatalystUser && !isPLG
}, {
  key: '/home',
  name: 'Home',
  icon: HomeIcon,
  iconFilled: HomeFilledIcon,
  subMenu: [{
    key: '/home/apps/list',
    name: 'All Apps',
    icon: AppsIcon,
    iconFilled: GridFilledIcon,
    subPages: ['/list'],
    subPagesDepthIndex: 3,
    enabled: ({
      flags,
      isCatalystUser,
      isPLG
    }) => flags.homepage_plg && !isCatalystUser && !isPLG
  }, {
    key: '/home/apps/installed',
    name: 'Installed Apps',
    icon: AppsIcon,
    iconFilled: GridFilledIcon,
    subPages: ['/installed', '/details'],
    subPagesDepthIndex: 3,
    enabled: ({
      flags,
      isCatalystUser,
      isPLG
    }) => flags.homepage_plg && !isCatalystUser && !isPLG
  }]
}, {
  name: 'Inbox',
  icon: InboxIcon,
  iconFilled: InboxFilledIcon,
  subMenu: [{
    key: makeNavigationLink('messaging'),
    name: 'Text Messages',
    icon: SMSIcon,
    iconFilled: SmsFilledIcon,
    enabled: ({
      hasPermission,
      isPLG
    }) => hasPermission('communication.view_smslog') && !isPLG
  }, {
    key: makeNavigationLink('voice-agent-calls'),
    name: 'Voice Calls',
    icon: CallIcon,
    iconFilled: CallFilledIcon,
    // Voice Forwarding also produces real calls to show, so it gets the call list too.
    enabled: ({
      hasIntegration,
      isCatalystUser
    }) => (hasIntegration('voice_agent') || hasIntegration('voice_forwarding') || hasIntegration('aircall') || hasIntegration('calltools') || hasIntegration('cinch_phones')) && !isCatalystUser
  }, {
    key: makeNavigationLink('try-out-voice-agent'),
    name: 'Voice Calls',
    icon: CallIcon,
    iconFilled: CallFilledIcon,
    tag: 'New',
    enabled: ({
      hasIntegration,
      isCatalystUser
    }) => !hasIntegration('voice_agent') && !hasIntegration('voice_forwarding') && !hasIntegration('aircall') && !hasIntegration('calltools') && !hasIntegration('cinch_phones') && !isCatalystUser
  }, {
    key: makeNavigationLink('reviews'),
    name: 'Reviews',
    icon: ReviewIcon,
    iconFilled: ReviewFilledIcon,
    enabled: ({
      hasIntegration,
      isPLG
    }) => hasIntegration('reviews') && !isPLG
  }, {
    key: makeNavigationLink('survey-responses'),
    name: 'Survey Responses',
    icon: SurveyResponsesIcon,
    enabled: ({
      hasIntegration,
      isPLG
    }) => hasIntegration('surveys') && !isPLG
  }, {
    key: makeNavigationLink('schedules'),
    name: 'Appointments',
    icon: CalendarAllIcon,
    enabled: ({
      hasIntegration
    }) => hasIntegration('calendar')
  }, {
    key: makeNavigationLink('try-out-scheduler'),
    name: 'Appointments',
    icon: CalendarAllIcon,
    tag: 'New',
    enabled: ({
      hasIntegration,
      isPLG,
      flags,
      isCatalystUser
    }) => !hasIntegration('calendar') && !isCatalystUser && (isPLG ? !!flags['scheduler-plg-signup'] : !!flags['scheduler-contracted-upsell'])
  }, {
    key: makeNavigationLink('task-manager'),
    name: 'Task Manager',
    icon: FactCheckIcon,
    iconFilled: FactCheckFilledIcon,
    enabled: ({
      hasIntegration,
      isPLG
    }) => hasIntegration('cinch_task_manager') && !isPLG
  }]
}, {
  name: 'Marketing',
  icon: MarketingIcon,
  iconFilled: MarketingFilledIcon,
  subMenu: [{
    key: '/customer-journeys',
    name: 'Journeys',
    icon: JourneyIcon,
    iconFilled: JourneyFilledIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('journey.view_journey') && !isCatalystUser && !isPLG
  }, {
    key: '/sms-broadcasts',
    name: 'Text Broadcasts',
    icon: BroadcastsIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('communication.view_smsbroadcast') && !isCatalystUser && !isPLG
  }, {
    key: '/email-broadcasts',
    name: 'Email Broadcasts',
    icon: BroadcastsIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('communication.view_smsbroadcast') && !isCatalystUser && !isPLG
  }, {
    key: '/manage-email-broadcasts',
    name: 'Managed Email Broadcasts',
    icon: JourneyFilledIcon,
    enabled: ({
      hasPermission,
      hasChildrenCompanies,
      isCatalystUser,
      isPLG
    }) => hasPermission('communication.view_smsbroadcast') && hasChildrenCompanies && !isCatalystUser && !isPLG,
    viewBox: '0 0 1 1'
  }]
}, {
  name: 'Assets',
  icon: AssetsIcon,
  iconFilled: AssetsFilledIcon,
  subMenu: [{
    key: '/segments',
    name: 'Segments',
    icon: SegmentIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('customer.view_segment') && !isCatalystUser && !isPLG,
    subPages: ['/create-segment']
  }, {
    key: '/templates',
    name: 'Templates',
    icon: TemplatesIcon,
    iconFilled: TemplatesFilledIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('template.view_template') && !isCatalystUser && !isPLG
  }, {
    key: '/files',
    name: 'File Manager',
    icon: FileManagerIcon,
    iconFilled: FileManagerFilledIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('files.view_files') && !isCatalystUser && !isPLG
  }, {
    key: '/coupons',
    name: 'Coupons',
    icon: CouponIcon,
    iconFilled: CouponFilledIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => (hasIntegration('loyalty') || hasIntegration('isi') || hasIntegration('coupons')) && !isCatalystUser && !isPLG
  }, {
    key: '/forms',
    name: 'Forms',
    icon: WebFormIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('customer.view_segment') && !isCatalystUser && !isPLG
  }, {
    key: '/surveys',
    name: 'Surveys',
    icon: ListAltIcon,
    iconFilled: ListAltFilledIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('surveys') && !isCatalystUser && !isPLG
  }, {
    key: '/landing-pages',
    name: 'Landing Pages',
    icon: LandingPagesIcon,
    enabled: ({
      hasIntegration,
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasIntegration('convrrt') && hasPermission('integration.manage_landing_pages') && !isCatalystUser && !isPLG
  }, {
    key: '/repeat-transaction-calculator-list',
    name: 'Repeat Transaction Calculator',
    icon: RepeatTransactionCalculatorIcon,
    enabled: ({
      hasIntegration,
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasIntegration('repeat_transaction_calculator') && (hasPermission('repeat_transaction_calculator.view_transactioncalculatorrule') || hasPermission('repeat_transaction_calculator.view_transactioncalculatorresults')) && !isCatalystUser && !isPLG
  }, {
    key: '/motor-oem-recommendations/configure',
    name: 'Motor OEM Recommendations',
    subPages: ['/motor-oem-recommendations'],
    icon: RepeatTransactionCalculatorIcon,
    // TODO change icon...
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('motor_oem_recommendations') && !isCatalystUser && !isPLG // TODO get this working with permissions next story
  }, {
    key: '/prebuilt/install',
    name: 'Prebuilt Assets',
    subPages: ['/prebuilt'],
    icon: HandymanIcon,
    enabled: ({
      user,
      flags,
      isCatalystUser,
      isPLG
    }) => (user.is_superuser || flags.cinch_testers) && !isCatalystUser && !isPLG
  }]
}, {
  name: 'Data',
  icon: InsertChartDataIcon,
  iconFilled: InsertChartDataFilledIcon,
  subMenu: [{
    key: '/analytics-list',
    name: 'Analytics',
    icon: AnalyticsIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('analytics.view_view') && !isCatalystUser && !isPLG
  }, {
    key: '/customers',
    name: 'Customers',
    icon: CustomersIcon,
    iconFilled: CustomersFilledIcon,
    enabled: ({
      hasPermission
    }) => hasPermission('customer.view_customer')
  }, {
    key: makeNavigationLink('transactions'),
    name: 'Transactions',
    icon: TransactionIcon,
    iconFilled: TransactionFilledIcon,
    enabled: ({
      hasPermission,
      isPLG
    }) => hasPermission('customer.view_customer') && !isPLG
  }, {
    key: '/customer-groups',
    name: 'Customer Groups',
    icon: CustomerGroupsIcon,
    iconFilled: CustomerGroupsFilledIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('customergroups') && !isCatalystUser && !isPLG
  }, {
    key: '/imports',
    name: 'Import Data',
    icon: ImportIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('csvimport.change_import') && !isCatalystUser && !isPLG
  }, {
    key: '/drb-carwash',
    name: 'DRB Carwash',
    icon: ImportIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('drb_carwash') && !isCatalystUser && !isPLG
  }]
}, {
  name: 'Apps',
  icon: AppsIcon,
  iconFilled: AppsFilledIcon,
  subMenu: [{
    key: '/marketplace/list',
    name: 'Marketplace',
    icon: IntegrationsIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('integration.view_integration') && !isCatalystUser && !isPLG,
    subPages: ['/list'],
    subPagesDepthIndex: 2
  }, {
    key: '/marketplace/installed',
    name: 'Installed Apps & Integrations',
    icon: IntegrationsIcon,
    enabled: ({
      hasPermission,
      isCatalystUser,
      isPLG
    }) => hasPermission('integration.view_integration') && !isCatalystUser && !isPLG,
    subPages: ['/installed'],
    subPagesDepthIndex: 2
  }, {
    key: '/calendars',
    name: 'Scheduler',
    icon: Calendar30DaysIcon,
    iconFilled: Calendar30DaysFilledIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser
    }) => hasIntegration('calendar') && !isCatalystUser
  }, {
    key: '/integrations/manage/cinch_task_manager',
    name: 'Cinch Tasks',
    icon: FactCheckIcon,
    iconFilled: FactCheckFilledIcon,
    // CIN-6288: the Apps entry opens the Task Manager MANAGEMENT page
    // (description + "Manage stages & categories"). The task INBOX/list stays under the Inbox
    // section (Catalyst-visible there); managing the app is admin-only, so this
    // requires integration.view_credential and excludes Catalyst.
    enabled: ({
      hasPermission,
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasPermission('integration.view_credential') && hasIntegration('cinch_task_manager') && !isCatalystUser && !isPLG
  }, {
    // CIN-6585: QR Codes is a marketplace app, so it belongs in Apps and its nav entry
    // Goes STRAIGHT to /qr-codes, not to the integration manage page. Unlike Cinch Tasks
    // or Loyalty, this app has nothing to configure — the manage page would only ever be a
    // pass-through, so sending people there costs them a click for no reason. The manage
    // page still exists for the marketplace install flow and links through to the builder.
    //
    // Gated on hasIntegration('qr_code') so the entry only appears once the app is
    // installed, and on qr_code.view_qrcode rather than integration.view_credential —
    // this entry opens the app itself, so the app's own view permission is the right gate.
    key: '/qr-codes',
    name: 'QR Codes',
    icon: QrCodeIcon,
    iconFilled: QrCodeIcon,
    subPages: ['/qr-codes'],
    enabled: ({
      hasPermission,
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('qr_code') && hasPermission('qr_code.view_qrcode') && !isCatalystUser && !isPLG
  }, {
    key: '/apps/loyalty',
    name: 'Loyalty Rewards',
    icon: CouponIcon,
    iconFilled: CouponFilledIcon,
    enabled: ({
      hasPermission,
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasPermission('integration.view_credential') && hasIntegration('loyalty_v2') && !isCatalystUser && !isPLG,
    subPages: ['/loyalty'],
    subPagesDepthIndex: 2
  }, {
    // CinchPhones has nothing to configure - the account is provisioned on install - so
    // this goes straight to the app's own section rather than to
    // /integrations/manage/cinch_phones, the same reasoning as QR Codes above. The manage
    // page is skipped entirely for this integration (see overrideForwardList in
    // integrations-manage.component.js), since it would only ever show an empty
    // "automatically configured" notice.
    key: '/apps/cinch-phones',
    name: 'Cinch Phones',
    icon: CallIcon,
    iconFilled: CallFilledIcon,
    enabled: ({
      hasPermission,
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasPermission('integration.view_credential') && hasIntegration('cinch_phones') && !isCatalystUser && !isPLG
  }, {
    key: '/voice-agents',
    name: 'Voice Agents',
    icon: SupportAgentFilledIcon,
    iconFilled: SupportAgentFilledIcon,
    enabled: ({
      hasIntegration,
      isCatalystUser
    }) => hasIntegration('voice_agent') && !isCatalystUser
  }, {
    key: '/integrations/manage/testing_simulator',
    name: 'Testing Simulator',
    icon: ScienceIcon,
    iconFilled: ScienceFilledIcon,
    subPages: ['/testing_simulator'],
    subPagesDepthIndex: 3,
    enabled: ({
      hasIntegration,
      isCatalystUser,
      isPLG
    }) => hasIntegration('testing_simulator') && !isCatalystUser && !isPLG
  }]
}, {
  // Flag `cinch-ai-app` off: the external link to the Open WebUI fork, exactly as on develop.
  // Future: CINCHAI-127 removes it with the flag.
  key: 'https://ai.jrae.vm.cinch.io/',
  externalUrl: 'https://ai.jrae.vm.cinch.io/',
  name: 'Cinch AI',
  icon: SmartToyIcon,
  iconFilled: SmartToyIcon,
  enabled: ({
    flags,
    isCatalystUser,
    isPLG
  }) => legacyAiLinkShown(flags) && !isCatalystUser && !isPLG
}, {
  // Flag on: the in-app page (CINCHAI-110) replaces the external link.
  key: '/cinch-ai',
  name: 'Cinch AI',
  icon: SmartToyIcon,
  iconFilled: SmartToyIcon,
  // CINCHAI-122: `cinchAiAllowed` is the provider's one gate (flag `cinch-ai-app`, app installed, allow-list).
  enabled: ({
    isCatalystUser,
    isPLG,
    cinchAiAllowed
  }) => cinchAiAllowed && !isCatalystUser && !isPLG
}, {
  name: 'Support'
}];